import { handleNumberChange } from "@common/handleChange";
import InputField from "@common/InputRuleFeild";
import { getValue } from "@utils/lodash";
import { Modal } from "reactstrap";
import Select from "react-select";

function ExpenseRulesPopup(props: any) {
  const timeOptions = [
    { value: "day", label: "Day" },
    { value: "month", label: "Month" },
    { value: "year", label: "Year" },
  ];

  const customStyles = {
    control: (base: any) => ({
      ...base,
      minHeight: 40,
    }),
  };

  return (
    <Modal isOpen={props.isOpen} toggle={props.handleModal}>
      <div className="m-2">
        <div className="mt-2 px-4 d-flex justify-content-between align-items-center">
          <h6 className="header_text">Expense Rules</h6>
          <div
            className="close-image_container ms-3"
            onClick={() => {
              props.handleModal();
              props.reset();
            }}
          >
            <img className="close_image" src={`/images/close-black.svg`} />
          </div>
        </div>
        <hr />
      </div>

      <div className="px-4 mb-4 general-limits-form-holder">
        <div>
          <label className="form-label">Time Period</label>
          <Select
            styles={customStyles}
            options={timeOptions}
            onChange={(e: any) =>
              props.setRequest({
                ...props.request,
                limit_type: e.value,
              })
            }
            value={timeOptions.find(
              (item) => item.value === getValue(props, `request.limit_type`, "")
            )}
            isClearable={false}
          />
        </div>
        <div className="mt-3">
          <label className="form-label">Limit Value {getValue(props, `request.limit_type`, "") && (
            <>
            (In {getValue(props, `request.limit_type`, "")})
            </>
          )}</label>
          <InputField
            inputType="NUMBER"
            name="limit_value"
            value={getValue(props, `request.limit_value`, "")}
            onChange={(e: any) =>
              handleNumberChange(e, props.request, props.setRequest)
            }
            placeholder="Enter Expense amount limit"
          />
        </div>
        <div className="mt-3">
            <input
              type="checkbox"
              className="common-checkbox"
              style={{ verticalAlign: "middle" }}
              onChange={(e) => {
                props.setRequest({
                  ...props.request,
                  can_apply_multiple: e.target.checked,
                });
              }}
              checked={getValue(props, `request.can_apply_multiple`, true)}
            />
            <span className="ms-2">Can Apply Multiple</span>
        </div>
        <div className="add-popup-wrapper__cta-wrapper mt-0">
          <hr />
          <button
            className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
            onClick={() => {
              props.handleModal();
              props.reset();
            }}
          >
            Cancel
          </button>
          <button
            className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
            onClick={() => {
              props.handleSubmit();
              props.reset();
            }}
            disabled={props.isLoading}
          >
            {props.isLoading ? "Please wait..." : "Submit"}
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ExpenseRulesPopup;
